module.exports = __webpack_public_path__ + "img/check.a47f462a.gif";